import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { getTransactionCsv, getAccountCsv, getTraderCsv, getUserCsv, getCommodityCsv } from "./api";
import { DownloadCsvActionTypes } from "./constants";

function* getTransactionCsvFunction(data) {
    try {
        yield put({
            type: DownloadCsvActionTypes.GET_TRANSACTION_CSV_LOADING,
            payload: {},
        });
        const response = yield call(getTransactionCsv, data);
        if (response.data.status) {
            yield put({
                type: DownloadCsvActionTypes.GET_TRANSACTION_CSV_SUCCESS,
                payload: response.data,
            });
        } else {
            yield put({
                type: DownloadCsvActionTypes.GET_TRANSACTION_CSV_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        yield put({
            type: DownloadCsvActionTypes.GET_TRANSACTION_CSV_ERROR,
            payload: error,
        });
    }
};

function* getAccountCsvFunction(data) {
    try {
        yield put({
            type: DownloadCsvActionTypes.GET_ACCOUNT_CSV_LOADING,
            payload: {},
        });
        const response = yield call(getAccountCsv, data);
        if (response.data.status) {
            yield put({
                type: DownloadCsvActionTypes.GET_ACCOUNT_CSV_SUCCESS,
                payload: response.data,
            });
        } else {
            yield put({
                type: DownloadCsvActionTypes.GET_ACCOUNT_CSV_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        yield put({
            type: DownloadCsvActionTypes.GET_ACCOUNT_CSV_ERROR,
            payload: error,
        });
    }
};

function* getTraderCsvFunction(data) {
    try {
        yield put({
            type: DownloadCsvActionTypes.GET_TRADER_CSV_LOADING,
            payload: {},
        });
        const response = yield call(getTraderCsv, data);
        if (response.data.status) {
            yield put({
                type: DownloadCsvActionTypes.GET_TRADER_CSV_SUCCESS,
                payload: response.data,
            });
        } else {
            yield put({
                type: DownloadCsvActionTypes.GET_TRADER_CSV_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        yield put({
            type: DownloadCsvActionTypes.GET_TRADER_CSV_ERROR,
            payload: error,
        });
    }
};

function* getUserCsvFunction(data) {
    try {
        yield put({
            type: DownloadCsvActionTypes.GET_USER_CSV_LOADING,
            payload: {},
        });
        const response = yield call(getUserCsv, data);
        if (response.data.status) {
            yield put({
                type: DownloadCsvActionTypes.GET_USER_CSV_SUCCESS,
                payload: response.data,
            });
        } else {
            yield put({
                type: DownloadCsvActionTypes.GET_USER_CSV_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        yield put({
            type: DownloadCsvActionTypes.GET_USER_CSV_ERROR,
            payload: error,
        });
    }
};

function* getCommodityCsvFunction(data) {
    try {
        yield put({
            type: DownloadCsvActionTypes.GET_COMMODITY_CSV_LOADING,
            payload: {},
        });
        const response = yield call(getCommodityCsv, data);
        if (response.data.status) {
            yield put({
                type: DownloadCsvActionTypes.GET_COMMODITY_CSV_SUCCESS,
                payload: response.data,
            });
        } else {
            yield put({
                type: DownloadCsvActionTypes.GET_COMMODITY_CSV_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        yield put({
            type: DownloadCsvActionTypes.GET_COMMODITY_CSV_ERROR,
            payload: error,
        });
    }
};


export function* watchGetCsv() {
    yield takeEvery(DownloadCsvActionTypes.GET_TRANSACTION_CSV_FIRST, getTransactionCsvFunction);
    yield takeEvery(DownloadCsvActionTypes.GET_ACCOUNT_CSV_FIRST, getAccountCsvFunction);
    yield takeEvery(DownloadCsvActionTypes.GET_TRADER_CSV_FIRST, getTraderCsvFunction);
    yield takeEvery(DownloadCsvActionTypes.GET_USER_CSV_FIRST, getUserCsvFunction);
    yield takeEvery(DownloadCsvActionTypes.GET_COMMODITY_CSV_FIRST, getCommodityCsvFunction);
}

function* downloadCsvSaga() {
    yield all([
        fork(watchGetCsv),
    ]);
}
export default downloadCsvSaga;